import { render } from "./OtpValidate.vue?vue&type=template&id=9f9bf800"
import script from "./OtpValidate.vue?vue&type=script&lang=js"
export * from "./OtpValidate.vue?vue&type=script&lang=js"

import "./OtpValidate.vue?vue&type=style&index=0&id=9f9bf800&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__